import { Box } from '@mui/material';
import SelectBase from 'components/forms/fields/select-field/select-base/select-base.component';
import { useKitchenCapacityContext } from 'components/kitchen-capacity/kitchen-capacity.context';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CustomHeaderToolbar = () => {
  const { t } = useTranslation();

  const {
    orderLimits: { handleCalendarViewChange },
  } = useKitchenCapacityContext();

  const [calendarView, setCalendarView] = useState('week');

  const calendarViewTypes = [
    {
      label: t(
        'KitchenCapacity.orderLimits.calendar.customHeaderToolbar.calenderViews.list',
      ),
      id: 'list',
      test: 'OrderLimitsCalendar.Toolbar.CalenderViews.List.Button',
    },
    {
      label: t(
        'KitchenCapacity.orderLimits.calendar.customHeaderToolbar.calenderViews.week',
      ),
      id: 'week',
      test: 'OrderLimitsCalendar.Toolbar.CalenderViews.Week.Button',
    },
  ];

  const handleCalendarView = e => {
    setCalendarView(e.target.value);
    handleCalendarViewChange(e.target.value);
  };

  return (
    <Box data-testid="OrderLimitsCalendar.Toolbar">
      <SelectBase
        options={calendarViewTypes}
        onChange={handleCalendarView}
        value={calendarView}
        size="small"
        color="primary"
        fullWidth={false}
        data-testid="OrderLimitsCalendar.Toolbar.View.Select"
      />
    </Box>
  );
};

export default CustomHeaderToolbar;
